var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { Platform, StyleSheet, TextInput, View } from 'react-native';
import { FalsyFC, FalsyText, FlexStyleProps, PropsService, WebEventResponder } from "../../devsupport";
import { Interaction, styled } from "../../theme";
export
/**
 * Inputs let users enter and edit text.
 *
 * @extends React.Component
 *
 * @property {string} value - A value displayed in input field.
 *
 * @property {string} onChangeText - Called when the value should be changed.
 *
 * @property {() => void} onFocus - Called when input field becomes focused.
 *
 * @property {() => void} onBlur - Called when input field looses focus.
 *
 * @property {string} placeholder - A string to be displayed when there is no value.
 *
 * @property {boolean} disabled - Whether input field is disabled.
 * This property overrides `editable` property of TextInput.
 *
 * @property {ReactText | (TextProps) => ReactElement} label - String, number or a function component
 * to render above the input field.
 * If it is a function, expected to return a Text.
 *
 * @property {ReactText | (TextProps) => ReactElement} caption - String, number or a function component
 * to render below the input field.
 * If it is a function, expected to return a Text.
 *
 * @property {(ImageProps) => ReactElement} accessoryLeft - Function component
 * to render to start of the text.
 * Expected to return an Image.
 *
 * @property {(ImageProps) => ReactElement} accessoryRight - Function component
 * to render to end of the text.
 * Expected to return an Image.
 *
 * @property {(ImageProps) => ReactElement} captionIcon - Function component
 * to render to start of the *caption*.
 * Expected to return an Image.
 *
 * @property {string} status - Status of the component.
 * Can be `basic`, `primary`, `success`, `info`, `warning`, `danger` or `control`.
 * Defaults to *basic*.
 * Useful for giving user a hint on the input validity.
 * Use *control* status when needed to display within a contrast container.
 *
 * @property {string} size - Size of the component.
 * Can be `small`, `medium` or `large`.
 * Defaults to *medium*.
 *
 * @property {StyleProp<TextStyle>} textStyle - Customizes the style of the text field.
 *
 * @property {TextInputProps} ...TextInputProps - Any props applied to TextInput component.
 *
 * @overview-example InputSimpleUsage
 *
 * @overview-example InputStates
 * Input can be disabled with `disabled` property.
 *
 * @overview-example InputStatus
 * Or marked with `status` property, which is useful within forms validation.
 * An extra status is `control`, which is designed to be used on high-contrast backgrounds.
 *
 * @overview-example InputAccessories
 * Input may contain labels, captions and inner views by configuring `accessoryLeft` or `accessoryRight` properties.
 * Within Eva, Input accessories are expected to be images or [svg icons](guides/icon-packages).
 *
 * @overview-example InputSize
 * To resize Input, a `size` property may be used.
 *
 * @overview-example InputStyling
 * Input and it's inner views can be styled by passing them as function components.
 * ```
 * import { Input, Text } from '../..';
 *
 * <Input
 *   textStyle={{ ... }}
 *   label={evaProps => <Text {...evaProps}>Label</Text>}
 *   caption={evaProps => <Text {...evaProps}>Caption</Text>}
 * />
 * ```
 *
 * @overview-example InputTheming
 * In most cases this is redundant, if [custom theme is configured](guides/branding).
 */
let Input = (_dec = styled('Input'), _dec(_class = (_temp = class Input extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "textInputRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "webEventResponder", WebEventResponder.create(this));

    _defineProperty(this, "focus", () => {
      var _this$textInputRef$cu;

      (_this$textInputRef$cu = this.textInputRef.current) === null || _this$textInputRef$cu === void 0 ? void 0 : _this$textInputRef$cu.focus();
    });

    _defineProperty(this, "blur", () => {
      var _this$textInputRef$cu2;

      (_this$textInputRef$cu2 = this.textInputRef.current) === null || _this$textInputRef$cu2 === void 0 ? void 0 : _this$textInputRef$cu2.blur();
    });

    _defineProperty(this, "isFocused", () => {
      var _this$textInputRef$cu3;

      return (_this$textInputRef$cu3 = this.textInputRef.current) === null || _this$textInputRef$cu3 === void 0 ? void 0 : _this$textInputRef$cu3.isFocused();
    });

    _defineProperty(this, "clear", () => {
      var _this$textInputRef$cu4;

      (_this$textInputRef$cu4 = this.textInputRef.current) === null || _this$textInputRef$cu4 === void 0 ? void 0 : _this$textInputRef$cu4.clear();
    });

    _defineProperty(this, "onMouseEnter", () => {
      this.props.eva.dispatch([Interaction.HOVER]);
    });

    _defineProperty(this, "onMouseLeave", () => {
      this.props.eva.dispatch([]);
    });

    _defineProperty(this, "onTextFieldFocus", event => {
      this.props.eva.dispatch([Interaction.FOCUSED]);
      this.props.onFocus && this.props.onFocus(event);
    });

    _defineProperty(this, "onTextFieldBlur", event => {
      this.props.eva.dispatch([]);
      this.props.onBlur && this.props.onBlur(event);
    });

    _defineProperty(this, "getComponentStyle", source => {
      const flatStyles = StyleSheet.flatten(this.props.style);

      const _PropsService$allWith = PropsService.allWithRest(flatStyles, FlexStyleProps),
            {
        rest: inputContainerStyle
      } = _PropsService$allWith,
            containerStyle = _objectWithoutProperties(_PropsService$allWith, ["rest"]);

      const {
        textMarginHorizontal,
        textFontFamily,
        textFontSize,
        textFontWeight,
        textColor,
        placeholderColor,
        iconWidth,
        iconHeight,
        iconMarginHorizontal,
        iconTintColor,
        labelColor,
        labelFontSize,
        labelMarginBottom,
        labelFontWeight,
        labelFontFamily,
        captionMarginTop,
        captionColor,
        captionFontSize,
        captionFontWeight,
        captionFontFamily,
        captionIconWidth,
        captionIconHeight,
        captionIconMarginRight,
        captionIconTintColor
      } = source,
            containerParameters = _objectWithoutProperties(source, ["textMarginHorizontal", "textFontFamily", "textFontSize", "textFontWeight", "textColor", "placeholderColor", "iconWidth", "iconHeight", "iconMarginHorizontal", "iconTintColor", "labelColor", "labelFontSize", "labelMarginBottom", "labelFontWeight", "labelFontFamily", "captionMarginTop", "captionColor", "captionFontSize", "captionFontWeight", "captionFontFamily", "captionIconWidth", "captionIconHeight", "captionIconMarginRight", "captionIconTintColor"]);

      return {
        container: containerStyle,
        inputContainer: _objectSpread(_objectSpread({}, containerParameters), inputContainerStyle),
        captionContainer: {
          marginTop: captionMarginTop
        },
        text: {
          marginHorizontal: textMarginHorizontal,
          fontFamily: textFontFamily,
          fontSize: textFontSize,
          fontWeight: textFontWeight,
          color: textColor
        },
        placeholder: {
          color: placeholderColor
        },
        icon: {
          width: iconWidth,
          height: iconHeight,
          marginHorizontal: iconMarginHorizontal,
          tintColor: iconTintColor
        },
        label: {
          color: labelColor,
          fontSize: labelFontSize,
          marginBottom: labelMarginBottom,
          fontWeight: labelFontWeight,
          fontFamily: labelFontFamily
        },
        captionIcon: {
          width: captionIconWidth,
          height: captionIconHeight,
          tintColor: captionIconTintColor,
          marginRight: captionIconMarginRight
        },
        captionLabel: {
          fontSize: captionFontSize,
          fontWeight: captionFontWeight,
          fontFamily: captionFontFamily,
          color: captionColor
        }
      };
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      textStyle,
      label,
      caption,
      accessoryLeft,
      accessoryRight,
      captionIcon
    } = _this$props,
          textInputProps = _objectWithoutProperties(_this$props, ["eva", "textStyle", "label", "caption", "accessoryLeft", "accessoryRight", "captionIcon"]);

    const evaStyle = this.getComponentStyle(eva.style);
    return /*#__PURE__*/React.createElement(View, {
      style: evaStyle.container
    }, /*#__PURE__*/React.createElement(FalsyText, {
      style: [evaStyle.label, styles.label],
      component: label
    }), /*#__PURE__*/React.createElement(View, {
      style: [evaStyle.inputContainer, styles.inputContainer]
    }, /*#__PURE__*/React.createElement(FalsyFC, {
      style: evaStyle.icon,
      component: accessoryLeft
    }), /*#__PURE__*/React.createElement(TextInput, _extends({
      ref: this.textInputRef,
      placeholderTextColor: evaStyle.placeholder.color
    }, textInputProps, this.webEventResponder.eventHandlers, {
      style: [evaStyle.text, styles.text, platformStyles.text, textStyle],
      editable: !textInputProps.disabled,
      onFocus: this.onTextFieldFocus,
      onBlur: this.onTextFieldBlur
    })), /*#__PURE__*/React.createElement(FalsyFC, {
      style: evaStyle.icon,
      component: accessoryRight
    })), /*#__PURE__*/React.createElement(View, {
      style: [evaStyle.captionContainer, styles.captionContainer]
    }, /*#__PURE__*/React.createElement(FalsyFC, {
      style: evaStyle.captionIcon,
      component: captionIcon
    }), /*#__PURE__*/React.createElement(FalsyText, {
      style: [evaStyle.captionLabel, styles.captionLabel],
      component: caption
    })));
  }

}, _temp)) || _class);
const styles = StyleSheet.create({
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%'
  },
  captionContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  text: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto'
  },
  label: {
    textAlign: 'left'
  },
  captionLabel: {
    textAlign: 'left'
  }
});
const platformStyles = StyleSheet.create({
  text: Platform.select({
    default: null,
    android: {
      paddingVertical: 0,
      marginVertical: -2
    },
    web: {
      outlineWidth: 0
    }
  })
});